import {

    FaCar,

    FaMoneyBillWave,

} from "react-icons/fa";

import {

    GiAutoRepair,

} from "react-icons/gi";

import styles from "./CreateMenu.module.css";

const CreateMenu = ({

    onNavigate,

}) => {

    const items = [

        {

            id: "car",

            title: "خودروی جدید",

            subtitle: "افزودن خودرو/موتور سیکلت/کامیونت/اتوبوس و یا هرگونه وسیله نقلیه دیگر",

            icon: <FaCar />,

            path: "/add-car",

        },

        {

            id: "service",

            title: "سرویس جدید",

            subtitle: "تعریف سرویس دوره ای خودرو مثل تعویض روغن موتور، تعویض تسمه تایم و...",

            icon: <GiAutoRepair />,

            path: "/add-service",

        },

        {

            id: "expense",

            title: "هزینه جدید",

            subtitle: "ثبت تمامی هزینه های خودرو مثل تعمیرات، سوخت، جریمه و ...",

            icon: <FaMoneyBillWave />,

            path: "/add-expense",

        },

    ];

    return (

        <div className={styles.container}>

            {

                items.map(item => (

                    <button

                        key={item.id}

                        type="button"

                        className={styles.item}

                        onClick={() =>

                            onNavigate?.(

                                item.path

                            )

                        }

                    >

                        <div

                            className={styles.icon}

                        >

                            {item.icon}

                        </div>

                        <div

                            className={styles.content}

                        >

                            <h4>

                                {item.title}

                            </h4>

                            <span>

                                {item.subtitle}

                            </span>

                        </div>

                    </button>

                ))

            }

        </div>

    );

};

export default CreateMenu;